module.exports = __webpack_public_path__ + "static/media/I Get Up.cedcff4d.jpg";